import { HTTP } from '../../utils'

export const populateGuestUserToken = (openId) => {
  if (!openId) {
    return
  }
  return HTTP().get('/guest/login?openId=' + openId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateGuestUser = (token) => {
  if (!token) {
    return
  }

  return HTTP().get('/guest/user?token=' + token)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateEntityTypeLabelConfiguration = () => {
  return HTTP().get('/configuration/prelogin/entity_type_label_configuration')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/guest/api.js